import { DATE_FORMAT } from './Liveboard.constant'

import { get, camelCase } from 'lodash'

import moment from 'moment'
import HttpRequest from '@/config/axios.config'
import { isEmptyValue } from '@/utils/common'
import { getDisplayValue } from './util/LiveboardUtil'
import { COMPANY_SETTING_LIVEBOARD_SETTING } from '@/constant/user'

const momentToString = (momentDate: moment.Moment) => {
  return momentDate.format(DATE_FORMAT)
}

const setVariable = ({ key, value, type = 'category' }) => {
  return {
    value,
    type: type,
    target: ['variable', ['template-tag', key]],
  }
}

const getDateFromBody = (body, index) =>
  get(body, `datePicked[${index}]`, moment()).format('yyyy-MM-DD')

const transformToMetabaseQuery = (data) => {
  return data?.map((k) => k?.key)?.reduce((one, two) => `${one},${two}`)
}

const transformBody = (companyId, body, currentPeriod, showPeriod) => {
  let original = []
  // tenant key
  original.push(
    setVariable({
      type: 'category',
      key: 'company',
      value: companyId,
    })
  )

  if (get(body, 'datePicked', null) !== null) {
    const fromDate = getDateFromBody(body, 0)
    original.push(
      setVariable({
        key: 'from_date',
        value: fromDate,
        type: 'date/single',
      })
    )
    const toDate = getDateFromBody(body, 1)
    original.push(
      setVariable({
        key: 'to_date',
        value: toDate,
        type: 'date/single',
      })
    )
  }

  if (showPeriod) {
    // mock yearly
    original.push(
      setVariable({
        key: 'date_type',
        value: currentPeriod,
      })
    )
  }

  Object.keys(get(body, 'filter', {})).forEach((item: any) => {
    const _item = camelCase(item)

    const keyValue = get(body, `filter[${item}]`, []) as any[]
    const value = transformToMetabaseQuery(keyValue)

    original.push(
      setVariable({
        key: _item,
        value,
      })
    )
  })

  return {
    parameters: original,
  }
}

const transformCardRequest = (
  fromDate: string,
  toDate: string,
  companyId: string,
  body: any
) => {
  let original = []

  // tenant key
  original.push(
    setVariable({
      type: 'category',
      key: 'company',
      value: companyId,
    })
  )
  original.push(
    setVariable({
      key: 'from_date',
      value: fromDate,
      type: 'date/single',
    })
  )

  original.push(
    setVariable({
      key: 'to_date',
      value: toDate,
      type: 'date/single',
    })
  )

  Object.keys(get(body, 'filter', {})).forEach((item: any) => {
    const _item = camelCase(item)

    const keyValue = get(body, `filter[${item}]`, []) as any[]
    const value = transformToMetabaseQuery(keyValue)
    original.push(
      setVariable({
        key: _item,
        value,
      })
    )
  })

  return {
    parameters: original,
  }
}

export async function QSFFilterRef() {
  return await HttpRequest.get('properties')
}

export async function ProductFilterRef(field: string) {
  return await HttpRequest.get('/properties/filter', {
    params: {
      field,
      table: 'products',
      all: true,
    },
  })
}

export async function ProductSupplierRef() {
  return await HttpRequest.get('/products/suppliers', {
    params: { all: true },
  })
}

export async function TaskFilterData() {
  return await HttpRequest.get('tasks/task-filter')
}

export const getSupplierRef = async (company_id = '') => {
  return await HttpRequest.get(`/suppliers`, {
    params: {
      status: 'active',
      type: 'supplier',
      all: true,
      ...(!isEmptyValue(company_id) && { company_id }),
    },
  })
}

export const getCountryByCompany = async () => {
  return await HttpRequest.get(`/suppliers/countries`)
}

export const getLiveboardSettingRef = async (company_id) => {
  return await HttpRequest.get(`/company-settings`, {
    params: {
      type: 'string',
      name: COMPANY_SETTING_LIVEBOARD_SETTING,
      status: 'active',
      company_id,
    },
  })
}

export const ChartDataRef = async (
  companyId: string,
  chartItem: Object,
  body: any,
  currentPeriod: string
) => {
  try {
    const dataEndpoint = `${get(chartItem, 'configure.data_endpoint', '')}`
    const showPeriod = get(chartItem, 'show_period', true)
    const payload = {
      dataEndpoint,
      ...transformBody(companyId, body, currentPeriod, showPeriod),
    }
    const data = await HttpRequest.post('/metabase/private-card', payload)
    if (data.status === 500) return { rows: [], cols: [] }
    return data?.data?.data
  } catch (error) {
    return { rows: [], cols: [] }
  }
}

export const ScoreboardDataRef = async (
  item: any,
  datePicked: moment.Moment[],
  body: any,
  companyId: string
) => {
  const dataEndpoint = item?.configure.data_endpoint ?? ''
  try {
    const startDate = momentToString(get(datePicked, '[0]') as moment.Moment)
    const endDate = momentToString(get(datePicked, '[1]') as moment.Moment)
    const data = await HttpRequest.post('/metabase/private-card', {
      ...transformCardRequest(startDate, endDate, companyId, body),
      dataEndpoint: dataEndpoint,
    })
    if (data.status === 500) return { rows: [], cols: [] }
    return data?.data?.data
  } catch (error) {
    return { rows: [], cols: [] }
  }
}
